module.exports = __webpack_public_path__ + "static/media/icon-reporting.58e7fabf.svg";